import React from "react";
import numeral from "numeral";


type CmpPropsType = {
    valuesList: Array<number>,
    valuesSign: number,
    buttonTextFormat: string,
    onButtonClick: (valueCents:number) => void,
    currentValue:number,
};


export default function ClerkIncrementsButtonsGrid(props:CmpPropsType) {
    const {
        valuesList,
        valuesSign,
        onButtonClick,
        buttonTextFormat,
        currentValue,
    } = props;


    const btnClassName = valuesSign > 0 ? 'btn--increment' : 'btn--decrement';


    const handleIncrementButtonClick = (valueCents) => (evt) => {
        onButtonClick(valueCents);
    };


    return (
        <div className="clerk-bid-increments-grid">
            {
                valuesList.map(v => v * valuesSign).map((valueCents, cellIdx) => {
                    return (
                        <div key={cellIdx} className={`clerk-bid-increments-grid__cell`}>
                            <button type="button" className={`btn btn-webcast-clerk-increment ${btnClassName}`}
                                    disabled={currentValue && valueCents === currentValue}
                                    onClick={handleIncrementButtonClick(valueCents)}>{numeral(valueCents / 100).format(buttonTextFormat)}</button>
                        </div>
                    )
                })
            }
        </div>
    );

};


ClerkIncrementsButtonsGrid.defaultProps = {
    valueSign: 1,
    buttonTextFormat: '+0,0[.]00',
    currentValue: 0,
};

